/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { Coordinates } from './Coordinates';
import {
    CoordinatesFromJSON,
    CoordinatesFromJSONTyped,
    CoordinatesToJSON,
    CoordinatesToJSONTyped,
} from './Coordinates';

/**
 * 
 * @export
 * @interface CreatePlaceDto
 */
export interface CreatePlaceDto {
    /**
     * Mapbox unique identifier for the place
     * @type {string}
     * @memberof CreatePlaceDto
     */
    mapboxId: string;
    /**
     * Place name (short form)
     * @type {string}
     * @memberof CreatePlaceDto
     */
    name: string;
    /**
     * Full place name with hierarchy
     * @type {string}
     * @memberof CreatePlaceDto
     */
    placeName: string;
    /**
     * Mapbox feature type
     * @type {string}
     * @memberof CreatePlaceDto
     */
    featureType: CreatePlaceDtoFeatureTypeEnum;
    /**
     * Geographic coordinates
     * @type {Coordinates}
     * @memberof CreatePlaceDto
     */
    coordinates: Coordinates;
    /**
     * Address information
     * @type {Address}
     * @memberof CreatePlaceDto
     */
    address: Address;
    /**
     * URL of the place image
     * @type {string}
     * @memberof CreatePlaceDto
     */
    imageUrl?: string;
    /**
     * Mapbox relevance score
     * @type {number}
     * @memberof CreatePlaceDto
     */
    relevance?: number;
    /**
     * Wikidata identifier
     * @type {string}
     * @memberof CreatePlaceDto
     */
    wikidataId?: string;
    /**
     * Mapbox maki icon identifier
     * @type {string}
     * @memberof CreatePlaceDto
     */
    maki?: string;
    /**
     * POI categories (human-readable)
     * @type {Array<string>}
     * @memberof CreatePlaceDto
     */
    poiCategories?: Array<string>;
    /**
     * POI category IDs (canonical)
     * @type {Array<string>}
     * @memberof CreatePlaceDto
     */
    poiCategoryIds?: Array<string>;
    /**
     * Brand names associated with this place
     * @type {Array<string>}
     * @memberof CreatePlaceDto
     */
    brands?: Array<string>;
    /**
     * Brand IDs associated with this place
     * @type {Array<string>}
     * @memberof CreatePlaceDto
     */
    brandIds?: Array<string>;
}


/**
 * @export
 */
export const CreatePlaceDtoFeatureTypeEnum = {
    Country: 'country',
    Region: 'region',
    Postcode: 'postcode',
    District: 'district',
    Place: 'place',
    Locality: 'locality',
    Neighborhood: 'neighborhood',
    Address: 'address',
    Poi: 'poi'
} as const;
export type CreatePlaceDtoFeatureTypeEnum = typeof CreatePlaceDtoFeatureTypeEnum[keyof typeof CreatePlaceDtoFeatureTypeEnum];


/**
 * Check if a given object implements the CreatePlaceDto interface.
 */
export function instanceOfCreatePlaceDto(value: object): value is CreatePlaceDto {
    if (!('mapboxId' in value) || value['mapboxId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('placeName' in value) || value['placeName'] === undefined) return false;
    if (!('featureType' in value) || value['featureType'] === undefined) return false;
    if (!('coordinates' in value) || value['coordinates'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function CreatePlaceDtoFromJSON(json: any): CreatePlaceDto {
    return CreatePlaceDtoFromJSONTyped(json, false);
}

export function CreatePlaceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePlaceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'mapboxId': json['mapboxId'],
        'name': json['name'],
        'placeName': json['placeName'],
        'featureType': json['featureType'],
        'coordinates': CoordinatesFromJSON(json['coordinates']),
        'address': AddressFromJSON(json['address']),
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'relevance': json['relevance'] == null ? undefined : json['relevance'],
        'wikidataId': json['wikidataId'] == null ? undefined : json['wikidataId'],
        'maki': json['maki'] == null ? undefined : json['maki'],
        'poiCategories': json['poiCategories'] == null ? undefined : json['poiCategories'],
        'poiCategoryIds': json['poiCategoryIds'] == null ? undefined : json['poiCategoryIds'],
        'brands': json['brands'] == null ? undefined : json['brands'],
        'brandIds': json['brandIds'] == null ? undefined : json['brandIds'],
    };
}

  export function CreatePlaceDtoToJSON(json: any): CreatePlaceDto {
      return CreatePlaceDtoToJSONTyped(json, false);
  }

  export function CreatePlaceDtoToJSONTyped(value?: CreatePlaceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mapboxId': value['mapboxId'],
        'name': value['name'],
        'placeName': value['placeName'],
        'featureType': value['featureType'],
        'coordinates': CoordinatesToJSON(value['coordinates']),
        'address': AddressToJSON(value['address']),
        'imageUrl': value['imageUrl'],
        'relevance': value['relevance'],
        'wikidataId': value['wikidataId'],
        'maki': value['maki'],
        'poiCategories': value['poiCategories'],
        'poiCategoryIds': value['poiCategoryIds'],
        'brands': value['brands'],
        'brandIds': value['brandIds'],
    };
}

